import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaHome, FaCarSide, FaThLarge, FaSignOutAlt,FaList } from "react-icons/fa";
import "../App.css";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/adminLogin");
  };

  const navLinks = [
    { path: "/adminDashboard", label: "Home", icon: <FaHome /> },
    { path: "/adminDashboard/vehicleEntry", label: "Vehicle Entry", icon: <FaCarSide /> },
    { path: "/adminDashboard/editSlots", label: "Set Slots", icon: <FaThLarge /> },
    { path: "/adminDashboard/allVehicleList", label: "Vehicle List", icon: <FaList /> }
  ];

  return (
    <div
      className="navbar shadow-sm"
      style={{
        background: "linear-gradient(90deg, #0d6efd, #0dcaf0)",
        padding: "0.5rem 1rem",
      }}
    >
      <nav className="navbar navbar-expand-lg w-100">
        <div className="container-fluid">
          {/* Brand */}
          <span
            className="navbar-brand fw-bold text-white"
            style={{ letterSpacing: "1px", fontSize: "1.3rem" }}
          >
            PMS
          </span>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler text-white border-white"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Links */}
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              {navLinks.map((link) => (
                <li key={link.path} className="nav-item mx-2">
                  <Link
                    to={link.path}
                    className={`nav-link d-flex align-items-center px-3 py-2 rounded-pill ${location.pathname === link.path
                      ? "active-link"
                      : "text-white"
                      }`}
                    style={{
                      transition: "all 0.3s ease",
                      fontWeight:
                        location.pathname === link.path ? "600" : "400",
                    }}
                  >
                    <span className="me-2">{link.icon}</span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Logout */}
            <button
              className="btn btn-danger rounded-pill px-3 d-flex align-items-center"
              onClick={handleLogout}
              style={{ fontWeight: "500" }}
            >
              <FaSignOutAlt className="me-2" /> Logout
            </button>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
